import { Wizard } from "../index";
import {
  IWizardStudentState,
  T_WIZARD_STUDENT_STEP,
  T_WIZARD_STUDENT_STEPS_PATH,
  WIZARD_STUDENT_STEPS_PATHS
} from "../interfaces";
import {
  WIZARD_STUDENT_DEFAULT_STATE,
  WIZARD_STUDENT_STEPS_CONFIGURATION,
  WIZARD_STUDENT_STEPS_ORDER
} from "./constants";
import React, { useCallback } from "react";
import { UserAPI } from "../../../API/userApi";
import { useTranslation } from "react-i18next";
import { useContextHospi } from "../../../context/ContextHospi";

export const StudentWizard = () => {
  const { t } = useTranslation("student");
  const { cognitoUser, updateProfile } = useContextHospi();

  return (
    <Wizard<
      T_WIZARD_STUDENT_STEP,
      T_WIZARD_STUDENT_STEPS_PATH,
      IWizardStudentState,
      typeof WIZARD_STUDENT_STEPS_PATHS
    >
      stepsOrder={WIZARD_STUDENT_STEPS_ORDER}
      stepsPathsInState={WIZARD_STUDENT_STEPS_PATHS}
      stepsConfiguration={WIZARD_STUDENT_STEPS_CONFIGURATION}
      defaultState={WIZARD_STUDENT_DEFAULT_STATE}
      getWizardState={useCallback(() => {
        return UserAPI.wizardStudentGetState();
      }, [])}
      resetWizardState={useCallback((id) => {
        return UserAPI.wizardStudentReset(id);
      }, [])}
      finishWizard={useCallback(() => {
        return UserAPI.wizardStudentFinish();
      }, [])}
      getStepTitle={(stepName) => {
        return t(`wizard.steps.${stepName}.title`, {
          defaultValue: null
        });
      }}
      getStepDescription={(stepName) => {
        return t(`wizard.steps.${stepName}.description`, {
          defaultValue: null
        });
      }}
      getOverviewStepTitle={(stepName) => {
        return t(`wizard.steps.${stepName}.titleOverview`, {
          defaultValue: null
        });
      }}
      onFinished={useCallback(() => {
        UserAPI.getUser(cognitoUser?.id!).then((user) => {
          updateProfile(user);
        });
      }, [cognitoUser?.id, updateProfile])}
    />
  );
};
